<template>
  <div class="voice-room-gift" @click.stop>
    <div class="mask" @click="closeDialog" v-show="visible"></div>
    <div class="main" v-show="visible" @click.stop>
      <div class="user-box">
        <span>{{$t('components_voiceroom_component_gift_1876')}}</span>
        <div class="list-box">
          <div
            class="user-item"
            v-for="item of userList"
            :key="item.user.userUuid"
            @click="toggleSelectUser(item)"
          >
            <img :src="item.user.avatarURL" alt="" srcset="" />
            <i class="el-icon-success" v-if="item.isSelect"></i>
          </div>
        </div>
        <el-button
          type="primary"
          round
          size="mini"
          @click="allSelectUser"
          v-if="userList.length > 1"
          >{{$t('components_voiceroom_component_gift_1877')}}</el-button
        >
      </div>
      <span class="total-value" v-show="activeName == 'beg'">{{$t('components_voiceroom_component_gift_1878', [ totalValue ])}}</span>
      <el-tabs class="tab-box" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('upgrade_page_views_master_components_rank_list_233')" name="gift">
          <ul class="gift-box">
            <li
              class="gift-item"
              v-for="(item, index) of giftList"
              :key="item.id"
              :class="{
                active:
                  item.id === sendGiftParams.giftId && index === selectIndex
              }"
              @click="selectGift(item, index)"
            >
              <img class="gift-image" :src="item.imageUrl" alt="" />
              <div class="gift-name">{{ item.name }}</div>
              <div v-if="item.recommend">
                {{ item.recommend }}
              </div>
              <div class="price-box" v-else>
                <img
                  class="icon-diamond"
                  src="~@/assets/image/icons/diamond.png"
                  alt=""
                  srcset=""
                />
                <span>{{ item.paymentAmount }}</span>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane :label="$t('components_voiceroom_component_gift_1879')" name="beg">
          <ul class="gift-box">
            <li
              class="gift-item"
              v-for="(item, index) of packSackList"
              :key="item.id + '' + index"
              :class="{
                active:
                  item.id === sendGiftParams.giftId && index === selectIndex
              }"
              @click="selectGift(item, index)"
            >
              <img class="gift-image" :src="item.imageUrl" alt="" />
              <div class="gift-name">{{ item.name }}</div>
              <div v-if="item.recommend">
                {{ item.num ? $t('components_voiceroom_component_gift_1880') : item.recommend }}
              </div>
              <div class="price-box" v-else>
                <img
                  class="icon-diamond"
                  src="~@/assets/image/icons/diamond.png"
                  alt=""
                  srcset=""
                />
                <!-- <span>{{ item.num ? '已拥有' : item.paymentAmount }}</span> -->
                <span>{{ item.paymentAmount }}</span>
              </div>
              <div class="count" v-if="item.num">{{ item.num }}</div>
            </li>
          </ul>
        </el-tab-pane>
      </el-tabs>
      <div class="action">
        <div class="box-tip" @click="showGiftTip">
          <span>{{$t('components_voiceroom_component_gift_1881')}}</span>
          <img src="../images/question.webp" />
        </div>
        <div class="select-box">
          <el-select
            class="select-count"
            v-model="sendGiftParams.count"
            filterable
            :filter-method="filterMethod"
          >
            <el-option
              v-for="item in giftCounts"
              :key="item.name"
              :label="item.value"
              :value="item.value"
            >
              <span style="float: left">{{ item.value }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                item.name
              }}</span>
            </el-option>
          </el-select>
          <el-button
            class="btn-send"
            type="primary"
            round
            size="mini"
            v-loading="sendGiftLoading"
            @click="handleSendGift"
            >{{ buttonText }}</el-button
          >
        </div>
      </div>
    </div>
    <gift-tip ref="giftTip"></gift-tip>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import {
  getGiftList as getGiftListRequest,
  getPackSack,
  sendGift
} from '@/api/voice-room';
import CurrentUserProvider from '@/components/VoiceRoom/currentUserProvider';
// import SeatProvider from '@/components/VoiceRoom/seatProvider';
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';
import giftTip from './gift-tip';
import { mapGetters } from 'vuex';

export default {
  name: 'Gift',
  components: {
    giftTip
  },
  data() {
    return {
      activeName: 'gift',
      giftList: [],
      sendGiftParams: {
        optionalToUuidList: [],
        playerUserUuid: '',
        count: 1,
        roomUid: '',
        boxFrom: 'store',
        giftId: ''
      },
      userList: [],
      packSackList: [],
      visible: false,
      sendGiftLoading: false,
      giftCounts: [
        {
          value: 1,
          label: 'x1',
          name: i18n.t('components_sendgifts_index_428')
        },
        {
          value: 10,
          label: 'x10',
          name: i18n.t('components_sendgifts_index_429')
        },
        {
          value: 99,
          label: 'x99',
          name: i18n.t('components_sendgifts_index_430')
        },
        {
          value: 188,
          label: 'x188',
          name: i18n.t('components_sendgifts_index_431')
        },
        {
          value: 520,
          label: 'x520',
          name: i18n.t('components_sendgifts_index_432')
        },
        {
          value: 1314,
          label: 'x1314',
          name: i18n.t('components_sendgifts_index_433')
        }
      ],
      selectIndex: null,
      selectGiftItem: {},
      toTargetUser: false
    };
  },
  computed: {
    ...mapGetters(['accountInfo']),

    diamondBalance() {
      return this.accountInfo ? this.accountInfo.diamondBalance || 0 : 0;
    },
    balance() {
      return this.accountInfo ? this.accountInfo.balance || 0 : 0;
    },
    userInfo() {
      return CurrentUserProvider.userInfo;
    },
    uuid() {
      return this.userInfo.uuid;
    },
    nickName() {
      return this.userInfo.nickname;
    },
    level() {
      return this.userInfo.level;
    },
    selectUsers() {
      return (
        this.userList.filter(item => item.user.userUuid && item.isSelect) || []
      );
    },
    buttonText() {
      if (this.activeName === 'gift') {
        return i18n.t('components_voiceroom_component_gift_1882');
      } else {
        const boxIdList = [101, 102, 103];
        if (boxIdList.includes(this.sendGiftParams.giftId)) {
          return this.selectUsers.length ? i18n.t('components_voiceroom_component_gift_1882') : i18n.t('components_voiceroom_component_gift_1883');
        } else {
          return i18n.t('components_voiceroom_component_gift_1882');
        }
      }
    },
    totalValue() {
      let price = 0;
      if (this.packSackList && this.packSackList.length) {
        this.packSackList.forEach(item => {
          if (item.num && item.paymentAmount) {
            price += item.num * item.paymentAmount;
          }
        });
      }
      return price;
    }
  },
  methods: {
    filterMethod(nVal) {
      let num = nVal;
      const regex = /^\d+$/;
      if (regex.test(nVal)) {
        num = Number(nVal);
      } else {
        if (num) {
          num = 0;
        } else {
          return this.giftCounts;
        }
      }
      const res = this.giftCounts.every(item => item.value != num);
      if (nVal && res) {
        const item = this.giftCounts.find(item => item.name === i18n.t('components_voiceroom_component_gift_1884'));
        if (item) {
          item.value = num;
          item.label = 'x' + num;
        } else {
          this.giftCounts.unshift({
            value: num,
            label: 'x' + num,
            name: i18n.t('components_voiceroom_component_gift_1884')
          });
        }
      }
      this.sendGiftParams.count = num;
      console.log(this.sendGiftParams.count);
      return this.giftCounts;
    },
    init(userList, toTargetUser) {
      this.toTargetUser = toTargetUser;
      this.userList = userList.filter(item => {
        return item.user.userUuid != this.uuid;
      });
      console.log(this.userList);
      this.visible = true;
      if (this.userList.length === 1) {
        this.userList[0]['isSelect'] = true;
      }
      this.addClickListener();
    },
    addClickListener() {
      this.$nextTick(() => {
        document.body.addEventListener('click', this.closeDialog);
      });
    },
    removeClickListener() {
      document.body.removeEventListener('click', this.closeDialog);
    },
    closeDialog() {
      this.visible = false;
      document.body.removeEventListener('click', this.closeDialog);
    },
    formatGiftCount(count) {
      return parseInt(count.substring(1));
    },
    handleClick() {},
    async getGiftList() {
      const { data } = await getGiftListRequest();
      this.giftList = data;
    },
    async getPackSack() {
      const { data } = await getPackSack();
      this.packSackList = data;
    },
    async handleSendGift() {
      if (this.sendGiftLoading) {
        return;
      }
      if (!this.sendGiftParams.giftId) {
        this.$message.error(i18n.t('components_voiceroom_component_gift_1885'));
        return;
      }
      if (!this.sendGiftParams.count) {
        this.$message.error(i18n.t('components_voiceroom_component_gift_1886'));
        return;
      }
      if (this.selectUsers.length === 0) {
        const boxIdList = [101, 102, 103];

        if (
          boxIdList.includes(this.sendGiftParams.giftId) &&
          this.activeName === 'beg'
        ) {
          console.log('打開宝箱');
        } else {
          this.$message.error(i18n.t('components_voiceroom_component_gift_1887'));
          return;
        }
      }
      const hasNum = this.selectGiftItem.num || 0;
      const userNum = this.selectUsers.length || 1;
      const count = hasNum - this.sendGiftParams.count * userNum;
      if (count < 0) {
        let price = 0;
        price = Math.abs(count) * this.selectGiftItem.paymentAmount;
        this.removeClickListener();
        if (price > this.diamondBalance) {
          const coinPrice = Math.ceil((price - this.diamondBalance) / 15);
          if (this.balance - coinPrice >= 0) {
            this.$confirm({
              content: i18n.t('components_voiceroom_component_critical_hit_box_1851', [coinPrice]),
              title: i18n.t('upgrade_page_views_order_confirm_order_291'),
              showCancelButton: false,
              confirmButtonText: i18n.t('upgrade_page_layout_header_41'),
              // cancelButtonText: '取消',
              closeOnClickOverlay: true
            }).then(async () => {
              try {
                this.sendGiftLoading = true;
                await this.$http.post('/account/convertAccount', {
                  accountKind: 'Balance',
                  convertAccountKind: 'Diamond',
                  convertAmount: coinPrice,
                  userUuid: this.uuid
                });
                // this.$store.dispatch('app/getUserAccount');
                await this.sendGift();
              } catch (error) {
                this.$store.dispatch('app/getUserAccount');
                this.$message.error(i18n.t('components_voiceroom_component_critical_hit_box_1852'));
                this.sendGiftLoading = false;
                this.addClickListener();
              }
            });
          } else {
            this.$confirm({
              content: i18n.t('components_voiceroom_component_critical_hit_box_1853'),
              title: i18n.t('upgrade_page_views_order_confirm_order_291'),
              showCancelButton: false,
              confirmButtonText: i18n.t('upgrade_page_layout_header_41'),
              // cancelButtonText: '取消',
              closeOnClickOverlay: true
            }).then(() => {
              window.open('/diamond-recharge', '_blank');
              this.addClickListener();
            });
          }
        } else {
          this.sendGiftLoading = true;
          this.sendGift();
        }
      } else {
        this.sendGiftLoading = true;
        this.sendGift();
      }

      // const money = this.selectUsers.length * this.sendGiftParams.count *
    },
    async sendGift() {
      this.sendGiftParams.optionalToUuidList = this.selectUsers.map(
        item => item.user.userUuid
      );
      this.sendGiftParams.playerUserUuid = this.uuid;
      this.sendGiftParams.roomUid = VoiceRoomIM.groupID;
      this.sendGiftParams.boxFrom =
        this.activeName === 'gift' ? 'store' : 'pack';
      try {
        const { data } = await sendGift(this.sendGiftParams);
        if (
          this.activeName == 'beg' &&
          this.selectUsers &&
          this.selectUsers.length === 0
        ) {
          this.showDrawResult(data);
        }
        this.sendGiftSuccess();
        this.addClickListener();
      } catch (error) {
        console.log(error);
        this.$message.error(i18n.t('components_voiceroom_component_gift_1888'));
        this.sendGiftLoading = false;
        this.$store.dispatch('app/getUserAccount');
        this.addClickListener();
      }
    },
    showDrawResult(drawResult) {
      if (drawResult && drawResult.boxGiftLst && drawResult.boxGiftLst.length) {
        const boxGiftLst = drawResult.boxGiftLst;
        boxGiftLst.sort((a, b) => {
          if (a.boxName === i18n.t('components_voiceroom_component_critical_hit_box_1849')) {
            return -1;
          }
          if (b.boxName === i18n.t('components_voiceroom_component_critical_hit_box_1849')) {
            return 1;
          }
          return b.boxPayAmount - a.boxPayAmount;
        });
        let drawName = '';
        boxGiftLst.forEach(item => {
          drawName = `${drawName}<div class="draw-result-item"><img class="draw-result-icon" src="${
            item.boxImageUrl
          }">${item.boxName}${
            item.boxPayAmount ? i18n.t('components_voiceroom_component_gift_1889',[item.boxPayAmount]) : ''
          }*${item.orderNum}</div>`;
        });
        this.$confirm({
          content: `
          ${drawName}
          `,
          title: i18n.t('components_voiceroom_component_critical_hit_box_1855'),
          showCancelButton: false,
          confirmButtonText: i18n.t('upgrade_page_layout_header_41'),
          closeOnClickOverlay: true,
          dangerouslyUseHTMLString: true
        });
      }
      drawResult = null;
      this.drawLoading = false;
    },
    sendGiftSuccess() {
      this.sendGiftLoading = false;
      this.sendGiftParams.giftId = '';
      if (this.activeName === 'beg') {
        this.getPackSack();
      }
      this.$store.dispatch('app/getUserAccount');
    },
    toggleSelectUser(item) {
      if (this.toTargetUser) {
        item.isSelect = true;
        return;
      }
      item.isSelect = !item.isSelect;
    },
    allSelectUser() {
      const result = this.userList.every(item => {
        return item.isSelect === true;
      });
      this.userList.forEach(item => {
        item.isSelect = !result;
      });
    },
    selectGift(item, index) {
      if (item.name === i18n.t('components_voiceroom_component_critical_hit_box_1849')) {
        this.$emit('open-diamond-box');
        this.closeDialog();
        return;
      }
      this.selectIndex = index;
      this.selectGiftItem = item;
      this.sendGiftParams.giftId = item.id;
    },
    showGiftTip() {
      this.$refs.giftTip.showDialog();
    }
  },
  created() {
    this.getGiftList();
    this.getPackSack();
  }
};
</script>
<style lang="scss" scoped>
.voice-room-gift {
  //   position: relative;
  font-size: 0;
}
.mask {
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 520px;
  height: 100%;
  z-index: 11;
}
.main {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 4px 20px 20px;
  border-radius: 6px;
  z-index: 12;
  .tab-box {
    /deep/ .el-tabs__header {
      padding-left: 24px;
    }
  }
  .total-value {
    position: absolute;
    right: 20px;
    top: 17px;
    font-size: 14px;
    color: white;
    opacity: 0.8;
  }
  .gift-box {
    height: 300px;
    overflow: auto;
    @include hideScrollBar(0, 0);
  }
  .gift-item {
    display: inline-flex;
    flex-direction: column;
    font-size: 12px;
    padding: 10px 10px;
    justify-content: center;
    align-items: center;
    color: white;
    border: 1px solid black;
    width: 120px;
    border-radius: 10px;
    position: relative;
    min-height: 140px;
    &:hover {
      cursor: pointer;
      border: 1px solid yellow;
    }
    &.active {
      border: 1px solid yellow;
    }
  }
  .gift-name {
    margin: 6px 0;
  }
  .gift-image {
    width: 60px;
  }
  .icon-diamond {
    width: 14px;
    margin-right: 2px;
  }
  .price-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .count {
    position: absolute;
    font-size: 12px;
    padding: 2px 4px;
    border-radius: 8px;
    color: white;
    background-color: #f72586;
    right: 8px;
    top: 8px;
  }
}
.user-box {
  position: absolute;
  top: -70px;
  left: 0;
  display: flex;
  align-items: center;
  background-color: black;
  color: white;
  border-radius: 12px;
  font-size: 0;
  width: calc(100% - 40px);
  margin: 0 14px 0;
  padding: 10px;
  > span {
    padding: 0 20px;
    font-size: 14px;
  }
  .list-box {
    max-width: 342px;
    overflow: auto;
    flex: auto;
    display: flex;
    @include hideScrollBar(0, 0);
    .user-item {
      position: relative;
      margin-right: 10px;
      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        object-fit: cover;
      }
      .el-icon-success {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 12px;
        color: yellow !important;
      }
    }
  }
}
.action {
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  align-content: center;
  height: 40px;
  > div {
    display: flex;
    align-items: center;
    height: 100%;
  }
  .btn-send {
    height: 100%;
    border-color: #f72586;
  }
  .box-tip {
    font-size: 12px;
    color: white;
    padding-left: 25px;
    img {
      width: 18px;
      height: auto;
      margin-left: 4px;
    }
  }
}
.select-count {
  /deep/ .el-input__inner {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-top-left-radius: 20px !important;
    border-bottom-left-radius: 20px !important;
    width: 100px;
  }
}
.btn-send {
  background-color: #f72586;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 100px;
  &:hover {
    color: white;
  }
}
</style>
<style lang="scss">
.voice-room-gift {
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs__item {
    color: white;
    &.is_active {
      color: yellow;
    }
  }
  .el-loading-mask {
    background: none;
  }
}
.el-message-box {
  .draw-result-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .draw-result-icon {
    width: 50px;
    margin-right: 4px;
  }
}
</style>
